interface ReferralFAQsType {
  question: string;
  answer: string;
  bullets?: string[];
}

export const ReferralFAQs: ReferralFAQsType[] = [
  {
    question: `How many points can I earn?`,
    answer: `You’ll earn 10 points per valid referral.`
  },
  {
    question: `What counts as a “valid referral”?`,
    answer: `A referral is valid when:`,
    bullets: [
      `1. The invited person is a new user (not an existing account).`,
      `2. They complete creating their profile (Please check the checklist).`,
      `3. They are not flagged as a duplicate or fake account.`
    ]
  },
  {
    question: `Can I refer myself or create extra accounts?`,
    answer: `No. Self-referrals, duplicate accounts, or bots will not count and may lead to disqualification.`
  },
  {
    question: `How do I share my referral link?`,
    answer: `Your referral link is unique to you and can be found on the Referral Page. Share it via social media, email, or direct messages.`
  },
  {
    question: `Do referrals help my contest rank?`,
    answer: `Yes! The higher your Soopra Score, the higher you rank to climb the leaderboard. Remember: referral points are bonus points on top of training, engagement, and completeness.`
  },
  {
    question: `Can I earn points beyond the contest?`,
    answer: `Referral points are not capped during the contest period. After the contest, Soopra.ai may introduce other referral rewards.`
  },
];
